// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { DomainConfig } from '../app/config/domain.config'; // uatcorporate.belairtrip.com

const apiBase = DomainConfig.isCorporate
  ? 'http://dev.belair.in/'
  : 'https://dev.belair.in/';

export const environment = {
  production: false,
  // Cheaptickets.co.in: https://dev.cheaptickets.co.in/    {{Dev}}
  // Cheapticket.in: https://cheapticket.in/  {{Prod}}
  // Belairtrip.com: https://belairtrip.com/  https://air.belairtrip.com/  {{Prod}}
  flightConfig: {
    apiUrl: apiBase, //flight API URL
    imageUrl: `${apiBase}img/air_logos/`, //flight image
  },
  hotelConfig: {
    apiUrl: 'https://api-dev.belhotel.in/b2c/' // Hotel API URL
  },
  carConfig: {
    apiUrl: '' // Car API URL
  },
  vISAConfig: {
    apiUrl: 'https://app.ivsource.com/' // VISA API URL
  },
  encKey: 'belairtrip@belairtrip.com',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
